import { Button, FormRow, FormSection } from "@omnabase/ui";
import { GB, formatFileSize, formatStorage, type AdminLimits, type LimitRead } from "@omnabase/shared";
import { useFormState } from "../../lib/save";

/** The back office's Storage box (the files round, 2026-10-30; brief rule 4, the red team's finding 13): what the workspace stores against
 *  the cap that applies, and the storage set by hand for this workspace in GB (a decimal allowed; empty uses the plan's), saved as bytes. */
const gbOf = (bytes: number | null) => (bytes === null ? "" : String(Math.round((bytes / GB) * 100) / 100));

export function AdminStorageSection({ used, limit, busy, onSave }: { used: number; limit: LimitRead | undefined; busy: boolean; onSave: (limits: AdminLimits) => Promise<unknown> }) {
  const [field, setField] = useFormState({ gb: gbOf(limit?.set ?? null) }, JSON.stringify(limit ?? null));
  const cap = limit?.effective ?? null;
  const bad = field.gb.trim() !== "" && !(Number(field.gb) >= 0);
  const save = () => { if (!bad) void onSave({ storageBytes: field.gb.trim() === "" ? null : Math.round(Number(field.gb) * GB) }); };
  return (
    <FormSection title="Storage" intro="What the workspace stores against its cap, and a cap set by hand for this workspace.">
      <FormRow label="Used" help={limit?.set === null || !limit ? "The plan's number applies." : `Set here; the plan has ${formatStorage(limit.plan ?? 0)}.`} inline>
        <span>{formatFileSize(used)} of {cap === null ? "no cap" : formatStorage(cap)}</span>
      </FormRow>
      <FormRow label="Storage set here" help={bad ? "A number of GB from 0; empty uses the plan's number." : "In GB; it stays through plan moves until it is cleared."} inline>
        <span className="ob-admin-limit">
          <input className="ob-dialog__input ob-admin-limit__input" type="number" min={0} step="any" aria-label="Storage set here (GB)" placeholder={limit?.plan ? `${formatStorage(limit.plan)} (plan)` : ""} value={field.gb} disabled={busy} onChange={(e) => setField({ gb: e.target.value })} />
          <Button size="sm" disabled={busy || bad} onClick={save}>Save storage</Button>
        </span>
      </FormRow>
    </FormSection>
  );
}
